import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

// #292 — "New": this person has not opened the event yet (per person; opening it in the
// event popup removes the mark). Used on the dashboard's Recent events rows and on event cards.
export function UnreadBadge({ className }: { className?: string }) {
  const { t } = useTranslation('events')
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full bg-amber-400 px-1.5 py-0 text-[10px] sm:text-[11px] font-semibold leading-4 text-amber-950',
        className,
      )}
    >
      {t('unread.new')}
    </span>
  )
}
